export enum ChartTypes {
  ENERGY,
  POWER,
}
